<template>
  <div class="text-center pt-16 pb-48">
    <NuxtImg
      width="180"
      height="180"
      src="/images/dashboard/onboarding/loading-onboarding.gif"
      alt="Loading-Onboarding.gif"
      class="mx-auto mb-16"
    />
    <h3 class="text-semantic-surface-on-surface font-bold text-lg mb-8">
      Personalising up your account
    </h3>
    <p class="text-semantic-surface-on-surface font-normal lg:text-base text-sm">
      Your account is being set up. Once it's ready,<br /> you'll arrive on your personal dashboard.
    </p>
    <img
      width="120"
      height="41"
      src="/images/clubplus-dark.svg"
      alt="clubplus-dark.svg"
      class="mx-auto mt-10"
    />
  </div>
</template>

<script setup>
defineOptions({
  name: 'AtomsAccountSetupLoader'
})
const emits = defineEmits(['account-setup-init'])
onMounted(() => {
  setTimeout(() => {
    emits('account-setup-init')
  }, 5000)
})
</script>

<style scoped>

</style>
